/*!

=========================================================
* Paper House React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Licensed under MIT (https://github.com/creativetimofficial/paper-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import { Button, Card, CardHeader, CardBody, CardFooter, CardTitle, InputGroup, InputGroupText, Input, Table, Row, Col } from "reactstrap";
import moment from 'moment-timezone';
import GraphHP from 'views/GraphHP';
import * as utility from 'components/Utils';


let glbDebug = true;

class House extends React.Component {

	constructor(props) {
		super(props);

		this.allZoomLevels = [ 1, 2, 3, 7, 14, 30, 3*30, 6*30, 1*365, 2*365, 3*365 ];
		this.defaultZoomLevel = 3;

		this.state = {
			isAuthorized: localStorage.getItem('isAuthorized'),
			password: '',
			batteryLevelDab: 0,
			batteryLevelKwb: 0,
			batteryLevelDabLastChecked: null,
			batteryLevelKwbLastChecked: null,
			thermostatSetting: [60,80],
			timeCheckedThermostatSetting: 0,
			temperatures: { "office": 0, "exterior": 0, "downstairs": 0, "livingroom": 0 },
			dataTemps: [ ],
			filteredDataTemps: [ ],
			filterForDataTemps: "",
			averageDataTemps: 42,
			timeCheckedTemperatureLivingRoom: 0,
			zoomOffset: 0,
			zoomLevel: this.allZoomLevels[this.defaultZoomLevel],
			lastPosX: 0,
			lastPosY: 0,
			mouseButton: "up",
		};

		this.HandleChange = this.HandleChange.bind(this);
		this.handleFilter = this.handleFilter.bind(this);
		this.getTemperatures = this.getTemperatures.bind(this);
		this.getThermostatSetting = this.getThermostatSetting.bind(this);
		this.getBatteryLevels = this.getBatteryLevels.bind(this);
		this.getRecentHomeTemperatures = this.getRecentHomeTemperatures.bind(this);
		this.requestThemostatInfo = this.requestThemostatInfo.bind(this);
		this.handleAuthorizationPassword = this.handleAuthorizationPassword.bind(this);
		this.handleOnKeyDown = this.handleOnKeyDown.bind(this);
		this.handleWheel = this.handleWheel.bind(this);
		this.handleMove = this.handleMove.bind(this);
		this.handleMouseButton = this.handleMouseButton.bind(this);
	}

	componentDidMount() {
		this.requestThemostatInfo();
		this.getTemperatures();
		this.getThermostatSetting();
		this.getBatteryLevels();
		this.getRecentHomeTemperatures();
		this.intervalThermostat = setInterval(() => this.getThermostatSetting(), 60*1000);	// every 60 seconds update the thermostat value
		this.intervalBattery = setInterval(() => this.getBatteryLevels(), 60*1000);	// every 60 seconds update the battery levels
		this.intervalTemperature = setInterval(() => { this.getRecentHomeTemperatures(); }, 60*1000);	// every 60 seconds update the temperature values
	}

	componentWillUnmount() {
		clearInterval(this.intervalThermostat);
		clearInterval(this.intervalBattery);
		clearInterval(this.intervalTemperature);
	}

	requestThemostatInfo() {
		const url = utility.getRootUrl()+'/requestThemostatInfo.php';
		const getThermostatSetting = this.getThermostatSetting;
		fetch(url)
			.then(function (response) {
					setTimeout( function() { getThermostatSetting(); }, 2 * 1000);
			})
	}

	getTemperatures() {
		const url = utility.getRootUrl()+'/getTemperatures.php';

		fetch(url)
			.then(function (response) {
				// console.log(url + " -> " + response.ok);
				return response.json();
			})
			.then(function (data) {
				// console.log("getTemperatures():  data: "); console.dir(data);
				var ss = moment.unix(Date.now() / 1000).tz('America/Los_Angeles').format('MMM D HH:mm:ss');
				this.setState({
						temperatures: data.temperatures,
						timeCheckedTemperatureLivingRoom: ss
						});
			}.bind(this))
			.catch(function (err) {
				console.log("failed to load ", url, err.stack);
			});
	}

	getThermostatSetting() {
		const url = utility.getRootUrl()+'/getThermostatSetting.php';

		fetch(url)
			.then(function (response) {
				// console.log(url + " -> " + response.ok);
				return response.json();
			})
			.then(function (data) {
				// console.log("data: "); console.dir(data);
				var ss = moment.unix(Date.now() / 1000).tz('America/Los_Angeles').format('MMM D HH:mm:ss');
				this.setState({ thermostatSetting: data.thermostat_setting, thermostat_state: data.thermostat_state, timeCheckedThermostatSetting: ss });
			}.bind(this))
		.catch(function (err) {
				console.log("failed to load ", url, err.stack);
			});
	}

	notifyForBatteryLevel( currentBatteryLevel, previousBatteryLevel, phoneNumber ) {
		var msg = "";
		if ( (currentBatteryLevel > previousBatteryLevel) && (currentBatteryLevel > 80) && (previousBatteryLevel !== 0) ) {
			msg = 'Stop charging phone to save battery life.  Charge level of phone is ' + currentBatteryLevel;
		}
		if ( (currentBatteryLevel < previousBatteryLevel) && (currentBatteryLevel < 20) && (previousBatteryLevel !== 0) ) {
			msg = 'Start charging phone to save battery life.  Charge level of phone is ' + currentBatteryLevel;
		}
		if ( msg !== "" ) {
			console.log("tested: " + currentBatteryLevel + " against " + previousBatteryLevel );
			console.log("sendSMS("+phoneNumber+"," + msg);
			utility.sendSMS( phoneNumber, msg );
		}
	}

	getBatteryLevels() {
		const url = utility.getRootUrl()+'/getBatteryLevels.php';

		fetch(url)
			.then(function (response) {
				// console.log(url + " -> " + response.ok);
				return response.json();
			})
			.then(function (data) {
				// console.log("data: "); console.dir(data);
				var batDab = data.dab;
				var batKwb = data.kwb;
				var timeDab = moment(batDab.whenLastChecked).format('MMM D, HH:mm');
				var timeKwb = moment(batKwb.whenLastChecked).format('MMM D, HH:mm');

				// Too many SMSs being sent; as this is done for each web site that is open on the House
				// this.notifyForBatteryLevel( batDab.battery, this.state.batteryLevelDab, "1-760-515-2323" );
				// this.notifyForBatteryLevel( batKwb.battery, this.state.batteryLevelKwb, "1-609-232-2323" );

				this.setState({
						batteryLevelDab: batDab.battery,
						batteryLevelKwb: batKwb.battery,
						batteryLevelDabLastChecked: timeDab,
						batteryLevelKwbLastChecked: timeKwb
						});

			}.bind(this))
		.catch(function (err) {
				console.log("failed to load ", url, err.stack);
			});
	}

	getRecentHomeTemperatures() {
		const url = utility.getRootUrl()+'/getRecentHomeTemperatures.php';

		fetch(url)
			.then(function (response) {
				console.log(url + " -> " + response.ok);
				return response.json();
			})
			.then(function (data) {
				let dataTemps = data;
				// console.log("dataTemps: "); console.dir(dataTemps);
				this.setState( { dataTemps: dataTemps } );
				// setTimeout( function() { this.handleFilter([]); }, 5 * 1000);
				let hf = this.handleFilter;
				setTimeout( function() { hf(null); }, 1 * 1000);
				// this.handleFilter( { target: { value: "" } } );
			}.bind(this))
		.catch(function (err) {
				console.log("failed to load ", url, err.stack);
			});
	}


	handleFilter( event ) {
		let filteredDataTemps = [ ];
		let values = event ? event.target.value.toLowerCase() : "";

		// if values is empty or only white space then show all rows
		if ( /^\s*$/.test(values) ) {
			this.setState( { filteredDataTemps: this.state.dataTemps } );
			filteredDataTemps = this.state.dataTemps;
		} else {
			// find only rows that have one of the words in values present
			filteredDataTemps = this.state.dataTemps.filter( function( row ) {
				let found = false;
				let words = values.split(/\s+/);
				words.forEach( function( word ) {
					if ( (word.length > 0) && row.location.toLowerCase().includes( word ) ) {
						found = true;
					}
				});
				return found;
			});

			// console.log(`filteredDataTemps: `); console.dir(filteredDataTemps);
			this.setState( { filteredDataTemps: filteredDataTemps } );
		}

		// console.log(`FilteredDataTemps: `); console.dir(filteredDataTemps);

		// find each row in dataTemps then take an average of the T
		// and add it to the filteredDataTemps
		let sum = 0;
		let cnt = 0;
		filteredDataTemps.forEach( function( row ) {
			if ( parseInt(row.T) > 0 ) {
				sum += row.T;
				cnt++;
			}
		});

		// console.log(`sum: ${sum} cnt: ${cnt}`);

		// avg is the average of the last 15 minutes of data with 1 decimal point
		let avg = Math.round( (sum / cnt) * 10 ) / 10;
		if ( cnt <= 0 ) {
			avg = '';
		}
			
		this.setState( { averageDataTemps: avg } );
		this.setState( { filterForDataTemps: values } );
	}


	HandleChange( values ) {
		this.setState( { thermostatSetting: values } );
	}

	handleAuthorizationPassword( ev ) {
		ev.preventDefault();

		if ( this.state.password === '00' ) {
			this.setState( { isAuthorized: true } );
			localStorage.setItem('isAuthorized', true );
		}
	}

	setPassword(val) {
		this.setState( { password: val } );
	}


	loginFirst() {
		return (
			<div className="Login">
			  <form onSubmit={this.handleAuthorizationPassword}>
				<InputGroup name="password">
				  <InputGroupText> Unlock Code </InputGroupText>
				  <Input
					value={this.state.password}
					onChange={e => this.setPassword(e.target.value)}
				  />
				</InputGroup>
				<Button block type="submit">
				  Login
				</Button>
			  </form>
			</div>
		);

	}

	handleMouseButton(ev) {
		if (ev.type === "mousedown") {
			this.setState({ mouseButton: "down"});
		} else {
			this.setState({ mouseButton: "up"});
		}
	}

	handleMove(ev) {
		if ( this.state.mouseButton === "down" ) {
			let zo = this.state.zoomOffset;

			let dx = this.state.lastPosX - ev.pageX;
			let dy = this.state.lastPosY - ev.pageY;

			if ( dy !== 0 ) {
				if ( dx > 0 ) {
					zo -= this.state.zoomLevel / 24;
					if ( zo < 0 ) {
						zo = 0;
					}
				} else {
					zo += this.state.zoomLevel / 24;
					if ( zo > 1000 ) {
						zo = 1000;
					}
				}

				this.setState({ lastPosX: ev.pageX, lastPosY: ev.pageY });
				this.setState({ zoomOffset: zo });
			}
		}
	}

	handleWheel(ev) {
		// console.dir( ev );

		let idxZoomLevel = this.allZoomLevels.findIndex( (lvl) => lvl >= this.state.zoomLevel);

		if ( ev.deltaY < 0 ) {
			idxZoomLevel += 1;
			if ( idxZoomLevel >= this.allZoomLevels.length ) {
				idxZoomLevel = this.allZoomLevels.length - 1;
			}
		} else if ( ev.deltaY > 0 ) {
			idxZoomLevel -= 1;
			if ( idxZoomLevel < 0 ) {
				idxZoomLevel = 0;
			}
		} else {
		}

		/* disable scrollwheel changing zoom level by commenting the next line */
		// this.setState({ zoomLevel: this.allZoomLevels[idxZoomLevel] });
	}

	handleOnKeyDown( ev ) {
		// console.log(`handleOnKeyDown(kc = ${ev.keyCode} key = ${ev.key} which = ${ev.which} code = ${ev.code})`);
		// console.dir( ev );

		let keyName = ev.key;

		let zo = this.state.zoomOffset;
		let idxZoomLevel = this.allZoomLevels.findIndex( (lvl) => lvl >= this.state.zoomLevel);

		switch (keyName) {
			case '0':
				idxZoomLevel = this.defaultZoomLevel;
				zo = 0;
				break;

			case 'Delete':
				console.log("Deleting localStorage!");
				localStorage.removeItem("David_1");
				localStorage.removeItem("Kathleen_1");
				localStorage.removeItem("dataFurnace");
				localStorage.removeItem("undefined_1");
				localStorage.removeItem("undefined_2");
				localStorage.removeItem("undefined_3");
				localStorage.removeItem("undefined_4");
				break;

			case '-':
			case '_':
			case 'ArrowDown':
				idxZoomLevel += 1;
				if ( idxZoomLevel >= this.allZoomLevels.length ) {
					idxZoomLevel = this.allZoomLevels.length - 1;
				}
				break;

			case '+':
			case '=':
			case 'ArrowUp':
				idxZoomLevel -= 1;
				if ( idxZoomLevel < 0 ) {
					idxZoomLevel = 0;
				}
				break;

			case 'l':
			case '<':
			case ',':
			case 'ArrowRight':
				zo -= this.state.zoomLevel / 2;
				if ( zo < 0 ) {
					zo = 0;
				}
				break;

			case 'h':
			case '>':
			case '.':
			case 'ArrowLeft':
				zo += this.state.zoomLevel / 2;
				if ( zo > 1000 ) {
					zo = 1000;
				}
				break;

			default:
				break;
		}
		this.setState({ zoomLevel: this.allZoomLevels[idxZoomLevel], zoomOffset: zo });
		// console.log(`onKeyUp(${keyName},e,handle)    zoomLevel = ${this.allZoomLevels[idxZoomLevel]} zoomOffset = ${zo}`);
	}


	render() {

		if ( ! glbDebug ) {
			if ( ! this.state.isAuthorized ) {
				return (
					<div className="content"
					style={{
						display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
					}}>
					{this.loginFirst()}
					</div>
				);
			}
		}

		return (
			<div className="content" onKeyDown={this.handleOnKeyDown} onWheel={(e) => this.handleWheel(e)} onMouseMove={this.handleMove} onMouseDown={this.handleMouseButton} onMouseUp={this.handleMouseButton} tabIndex="0" >
			  <Row>

				<Col lg="3" md="4" sm="6">
				  <Card className="card-stats">
					<CardBody>
					  <Row>
						<Col md="4" xs="5">
						  <img alt="Temp" height="60" src="/thermometer.svg" />
						</Col>
						<Col md="8" xs="1">
						  <div className="numbers">
							<p className="card-category"> Office / Living Room </p>
							<CardTitle tag="p">
								<span className="office-temperature"> {parseInt(this.state.temperatures["Office"] + 0.5,10)} </span>
									/
								<span className="livingroom-temperature"> {parseInt(this.state.temperatures["livingroom"] + 0.5,10)} </span>
								</CardTitle>
							<p />
						  </div>
						</Col>
					  </Row>
					</CardBody>
					<CardFooter>
					  <hr />
					  <div className="stats">
						<i className="fas fa-sync-alt" /> {this.state.timeCheckedThermostatSetting}
					  </div>
					</CardFooter>
				  </Card>
				</Col>

				<Col lg="3" md="4" sm="6">
				  <Card className="card-stats">
					<CardBody>
					  <Row>
						<Col md="4" xs="5">
						  <img alt="Temp" height="60" src="/thermometer.svg" />
						</Col>
						<Col md="8" xs="1">
						  <div className="numbers">
							<p className="card-category"> Downstairs / Outside </p>
							<CardTitle tag="p">
								<span className="downstairs-temperature"> {parseInt(this.state.temperatures["downstairs"] + 0.5,10)} </span>
									/
								<span className="exterior-temperature"> {parseInt(this.state.temperatures["exterior"] + 0.5,10)} </span>
								  </CardTitle>
							<p />
						  </div>
						</Col>
					  </Row>
					</CardBody>
					<CardFooter>
					  <hr />
					  <div className="stats">
						<i className="fas fa-sync-alt" /> {this.state.timeCheckedThermostatSetting}
					  </div>
					</CardFooter>
				  </Card>
				</Col>


				<Col lg="3" md="4" sm="6">
				  <Card className="card-stats" onClick={() => this.props.history.push('/thermostat') } >
					<CardBody>
					  <Row>
						<Col md="4" xs="5">
						  <div className="icon-big text-center icon-warning">
							<i className="nc-icon nc-tap-01 text-success" />
						  </div>
						</Col>
						<Col md="8" xs="7">
						  <div className="numbers">
							<p className="card-category"> Thermostat - {this.state.thermostat_state} </p>
							<CardTitle tag="p"> {this.state.thermostatSetting.join(" .. ")} </CardTitle>
							<p />
						  </div>
						</Col>
					  </Row>
					</CardBody>
					<CardFooter>
					  <hr />
					  <div className="stats">
						<i className="far fa-calendar" /> {this.state.timeCheckedThermostatSetting}
					  </div>
					</CardFooter>
				  </Card>
				</Col>

				<Col lg="3" md="4" sm="6">
				  <Card className="card-stats">
					<CardBody>
					  <Row>
						<Col md="4" xs="5">
						  <img alt="Temp" height="60" src="/battery-level.svg" />
						</Col>
						<Col md="8" xs="1">
						  <div className="numbers">
							<p className="card-category"> Battery Levels </p>
							<CardTitle tag="p">
								<small> dab: {this.state.batteryLevelDab}% </small>
								&nbsp;
								<small> kwb: {this.state.batteryLevelKwb}% </small>
							</CardTitle>
							<p />
						  </div>
						</Col>
					  </Row>
					</CardBody>
					<CardFooter>
					  <hr />
					  <div className="stats">
						<i className="fas fa-sync-alt" />  dab: {this.state.batteryLevelDabLastChecked} &nbsp; kwb: {this.state.batteryLevelKwbLastChecked}
					  </div>
					</CardFooter>
				  </Card>
				</Col>

			  </Row>

			  <Row>
				<Col md="12">
				  <Card>
					<CardHeader>
					  <CardTitle tag="h5"> Temperature (Days: {this.state.zoomLevel}) </CardTitle>
					  <p className="card-category">
						  <span className="office-temperature"> Office </span>
						  /
						  <span className="livingroom-temperature"> Upstairs Living Room </span>
						  /
						  <span className="downstairs-temperature"> Downstairs </span>
						  /
						  <span className="exterior-temperature"> Outside </span>
					  </p>
					</CardHeader>
					<CardBody style={{marginTop: -10}}>
					<GraphHP graphType="temperature" label="Temps" width={1200} height={300} urlData={"/getdata-temperature.php"} zoomLevel={this.state.zoomLevel} zoomOffset={this.state.zoomOffset} />
					</CardBody>
				  </Card>
				</Col>
			  </Row>

			  <Row>
				<Col md="12">
				<div style={{ display: 'flex', justifyContent: 'center' }}>
				<span className="px-2">
					Filter: <input type="text" value={this.state.filterForDataTemps} onChange={this.handleFilter} />
				</span>
				<span className="px-2"> Average: {this.state.averageDataTemps} </span>
				</div>
				  <Card>
					<CardHeader>
					  <CardTitle tag="h5"> Recent Home Temperatures </CardTitle>
					</CardHeader>
					<CardBody style={{marginTop: -10}}>
						<div style={{ display: 'flex', justifyContent: 'center' }}>
						<Table striped responsive className="text-center">
							<thead>
								<tr>
									<th>Location</th>
									<th>Temperature (°F)</th>
									<th>Humidity (%)</th>
									<th>Time</th>
								</tr>
							</thead>
							<tbody>
								{this.state.filteredDataTemps.map((item, index) => (
									<tr key={index}>
										<td>{item.location}</td>
										<td>{item.T}</td>
										<td>{item.H}</td>
										<td>{item.theTime}</td>
									</tr>
								))}
							</tbody>
						</Table>
						</div>
					</CardBody>
				  </Card>
				</Col>
			  </Row>

			</div>
		);
	}
}

export default House;
